import {
  Box,
  Flex,
  Text,
  Input,
  Select,
  Radio,
  RadioGroup,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";

const Approvals = () => {
  const [radioValue, setRadioValue] = useState("all");

  // Dummy data for table rows
  const requestData = [
    {
      project: "HSBC Winter Campaign",
      reference: "LLS15747",
      items: "3",
      priority: "Low",
      client: "HSBC Joanna Bloggs",
      accountmanager: "Me",
      deadline: "5/11/24",
      status: "Pending",
    },
    {
      project: "HSBC Branch Banners",
      reference: "LLS15747",
      items: "1",
      priority: "Low",
      client: "HSBC Joanna Bloggs",
      accountmanager: "Me",
      deadline: "5/11/24",
      status: "Pending",
    },
    {
      project: "HSBC Autumn Leaflet",
      reference: "LLS15747",
      items: "1",
      priority: "Low",
      client: "HSBC Joanna Bloggs",
      accountmanager: "Me",
      deadline: "5/11/24",
      status: "Completed",
    },
  ];

  return (
    <Box flex="1" pt="40px" px="8">
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="30px" color="#101828">
          Proof approvals
        </Text>
        {/* <Button background="#1e98d7" color="#ffffff" _hover="none" fontSize="14px">Create a New Request</Button> */}
      </Flex>

      {/* Filters Section */}
      <Flex gap={4} wrap="wrap" mb={6}>
      <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        <Select
          placeholder="Status (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
        <Select
          placeholder="Priority (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="pending">Low</option>
          <option value="approved">High</option>
        </Select>
      </Flex>

      {/* Radio Buttons */}
      <RadioGroup onChange={setRadioValue} value={radioValue} mb={12} color="#475467">
        <Stack direction="row" align="center" color="#475467">
          <Text fontWeight="semibold" fontSize="12px" color="#475467" mr={4}>
            View:
          </Text>
          <Radio
            value="all"
            mr={4}
          >
             <Text fontSize="12px">All approvals</Text>
          
          </Radio>
          <Radio
            value="approved"
            mr={4}
          >
            <Text fontSize="12px">My approvals</Text>
          </Radio>
        </Stack>
      </RadioGroup>

      {/* Responsive Table */}
      <Box overflowX="auto">
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Project
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Reference
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Items
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Priority
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Client
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Account manager
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Deadline{" "}
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Status
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              ></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index}>
                <Td pl={0} py={7} color="#475467" fontSize="12px">
                  {request.project}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.reference}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.items}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.priority}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.client}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.accountmanager}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.deadline}
                </Td>
                <Td pl={0}>
                  <Box
                         px="10px"
                         py="5px"
                         borderRadius="54px"
                         border="1px solid #4b5565"
                         backgroundColor="transparent"
                         fontSize="12px"
                         fontFamily="Inter, sans-serif"
                         color="#4b5565"
                         textAlign="center"
                         display="inline-block"
                         minWidth="50px" 
                         maxWidth="200px" 
                         width="auto" 
                         height="28px"
                         lineHeight="18px"
                         whiteSpace="nowrap" 
                  >
                    {request.status}
                  </Box>
                </Td>
                <Td
                  pl={0}
                  color="#475467"
                  fontSize="12px"
                  textDecoration="underline"
                  cursor="pointer"
                >
                  View
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default Approvals;
